export const pricingPlans = [
  // GOODIKIDS INDIA PLANS (prices in INR)
  {
    id: 'in-starter-monthly',
    region: 'IN',
    currency: 'INR',
    name: 'Starter Plan (Monthly)',
    price: 99,
    period: 'month',
    subtitle: 'Full access • 30 days',
    description: 'A great beginning to introduce good habits and see early positive changes.',
    features: [],
    highlighted: false
  },
  {
    id: 'in-smart-saver-quarterly',
    region: 'IN',
    currency: 'INR',
    name: 'Smart Saver Plan (Quarterly)',
    price: 249,
    period: '3 months',
    subtitle: 'Full access • 90 days • Save more',
    description: 'Enough time for children to get involved, enjoy learning, and become more consistent.',
    features: [],
    highlighted: false
  },
  {
    id: 'in-value-halfyearly',
    region: 'IN',
    currency: 'INR',
    name: 'Value Pack Plan (Half-Yearly)',
    price: 449,
    period: '6 months',
    subtitle: 'Full access • 180 days • Most chosen',
    description: 'A strong duration to build behaviour, confidence, kindness, and daily good habits naturally.',
    features: [],
    highlighted: false
  },
  {
    id: 'in-best-value-yearly',
    region: 'IN',
    currency: 'INR',
    name: 'Best Value Plan (Yearly)',
    price: 749,
    period: '12 months',
    subtitle: 'Full access • 365 days • Maximum savings',
    description: 'A complete year of emotional, social and moral development — shaping your child for life.',
    features: [],
    highlighted: true
  },

  // GOODIKIDS GLOBAL PLANS (prices in USD)
  {
    id: 'gl-starter-monthly',
    region: 'GLOBAL',
    currency: 'USD',
    name: 'Starter Plan (Monthly)',
    price: 2.99,
    period: 'month',
    subtitle: 'Full access • 30 days',
    description: 'A great beginning to introduce good habits and see early positive changes.',
    features: [],
    highlighted: false
  },
  {
    id: 'gl-smart-saver-quarterly',
    region: 'GLOBAL',
    currency: 'USD',
    name: 'Smart Saver Plan (Quarterly)',
    price: 6.99,
    period: '3 months',
    subtitle: 'Full access • 90 days • Save more',
    description: 'Enough time for children to get involved, enjoy learning, and become more consistent.',
    features: [],
    highlighted: false
  },
  {
    id: 'gl-value-halfyearly',
    region: 'GLOBAL',
    currency: 'USD',
    name: 'Value Pack Plan (Half-Yearly)',
    price: 12.99,
    period: '6 months',
    subtitle: 'Full access • 180 days • Most chosen',
    description: 'A strong duration to build behaviour, confidence, kindness, and daily good habits naturally.',
    features: [],
    highlighted: false
  },
  {
    id: 'gl-best-value-yearly',
    region: 'GLOBAL',
    currency: 'USD',
    name: 'Best Value Plan (Yearly)',
    price: 21.99,
    period: '12 months',
    subtitle: 'Full access • 365 days • Maximum savings',
    description: 'A complete year of emotional, social, and moral development — shaping your child for life.',
    features: [],
    highlighted: true
  }
];

export const features = [
  {
    id: 'fun-learning',
    title: 'Fun Way to Learn Good Habits',
    description:
      'Children learn kindness, honesty, respect, and manners through short, story-based quizzes, images and playful games — not boring lessons!',
    icon: 'Gamepad2'
  },
  {
    id: 'play-learn',
    title: 'Play and Learn Together',
    description:
      'Every tap feels like a game! Kids earn stars, badges, and trophies while building good behavior and confidence.',
    icon: 'Puzzle'
  },
  {
    id: 'safe-adfree',
    title: 'Safe and Ad-Free',
    description:
      'No ads, no chats, no harmful links — just a calm, positive world designed only for children.',
    icon: 'Shield'
  },
  {
    id: 'multilingual',
    title: 'Multilingual Learning',
    description:
      'Learn in Hindi, English, and more regional languages — with many more languages coming soon!',
    icon: 'Languages'
  },
  {
    id: 'ai-voice',
    title: 'AI Voice Narration',
    description:
      'Friendly voices guide every story, question, and answer in Hindi, English, and other languages. Perfect for listening-based learning.',
    icon: 'Headphones'
  },
  {
    id: 'stories-voices',
    title: 'Beautiful Stories and Voices',
    description:
      'A warm, storytelling way of asking questions with soft background sounds and child-friendly visuals that make each value come alive.',
    icon: 'BookOpen'
  },
  {
    id: 'rewards-certificates',
    title: 'Rewards and Certificates',
    description:
      'Children earn fun badges and printable certificates after every topic — boosting confidence with every success.',
    icon: 'Award'
  },
  {
    id: 'parent-dashboard',
    title: 'Parent Dashboard with Progress Tracking',
    description:
      'Track your child’s daily growth and download printable certificates to celebrate their achievements.',
    icon: 'BarChart'
  },
  {
    id: 'school-ready',
    title: 'Perfect for Schools Too',
    description:
      'Teachers can use Goodikids to teach values, empathy, and manners in classrooms with ease.',
    icon: 'Notebook'
  },
  {
    id: 'mascot',
    title: 'Friendly Mascot Companion',
    description:
      'The Goodikids elephant cheers, claps, and motivates children — turning every learning moment into a smile.',
    icon: 'Smile'
  },
  {
    id: 'multi-device',
    title: 'Works on All Devices',
    description:
      'Smooth performance on Android, iPhones, iPads, and tablets — with bright, easy-to-tap buttons made for kids.',
    icon: 'TabletSmartphone'
  },
  {
    id: 'daily-lessons',
    title: 'Short, Daily Lessons',
    description:
      'Just 10 minutes a day helps children learn patience, kindness, and calmness — gently nurturing character development step by step.',
    icon: 'Clock'
  },
  {
    id: 'real-life',
    title: 'Real-Life Learning',
    description:
      'Every story and quiz is based on real situations at home, school, and with friends — helping kids learn what’s right and why.',
    icon: 'Globe'
  },
  {
    id: 'motivating',
    title: 'Motivating and Positive',
    description:
      'Celebration sounds, friendly voiceovers, and colorful animations keep kids excited to learn more every day.',
    icon: 'Sparkles'
  },
  {
    id: 'purposeful',
    title: 'Purposeful Screen Time',
    description:
      'Transforms ordinary screen use into joyful learning that builds empathy, respect, and confidence.',
    icon: 'MonitorPlay'
  }
];

export const ageGroups = [
  {
    range: '4-5 years',
    title: 'Early Learners',
    description: 'Basic shapes, colors, numbers, and simple vocabulary'
  },
  {
    range: '5-6 years',
    title: 'Foundation Builders',
    description: 'Reading basics, counting, patterns, and problem-solving'
  },
  {
    range: '6-8 years',
    title: 'Young Explorers',
    description: 'Math fundamentals, science concepts, and language skills'
  },
  {
    range: '9-12 years',
    title: 'Advanced Learners',
    description: 'Complex topics, critical thinking, and advanced subjects'
  }
];

export const blogPosts = [
  {
    id: "5-ways-to-make-learning-fun",
    title: "5 Ways to Make Learning Fun for Young Children",
    excerpt: "Discover proven strategies to engage your child in learning activities that feel like play.",
    author: "Sarah Johnson",
    date: "January 15, 2025",
    category: "Education Tips",
    content: `
      <h2>Turn Learning Into Play</h2>
      <p>Children learn best when they are having fun. Instead of rigid lessons, try incorporating games, songs, and hands-on activities into their daily routine.</p>
      
      <h2>1. Use Storytelling</h2>
      <p>Stories capture imagination. Turn a math problem into a story about sharing apples with friends.</p>
      
      <h2>2. Gamify Daily Tasks</h2>
      <p>Make cleaning up a race or a matching game. Use rewards like stickers for completing tasks.</p>
      
      <h2>3. Learn in Nature</h2>
      <p>Take learning outside. Count leaves, identify colors in flowers, or watch bugs to learn about biology.</p>
      
      <h2>4. Use Music and Rhymes</h2>
      <p>Songs stick in memory. Use rhymes to teach alphabets, numbers, or good habits.</p>
      
      <h2>5. Be Positive</h2>
      <p>Encourage effort, not just results. A "Great job trying!" goes a long way.</p>
    `
  },
  {
    id: "benefits-of-mcq-learning",
    title: "The Benefits of MCQ-Based Learning",
    excerpt: "Why multiple-choice questions are an effective tool for measuring and improving comprehension.",
    author: "Dr. Michael Chen",
    date: "January 10, 2025",
    category: "Learning Methods",
    content: `
      <h2>Instant Feedback</h2>
      <p>MCQs provide immediate results, helping children correct mistakes instantly and learn faster.</p>
      
      <h2>Critical Thinking</h2>
      <p>Good MCQs require analyzing options and eliminating incorrect answers, which builds critical thinking skills.</p>
      
      <h2>Low Pressure</h2>
      <p>Choosing an answer is often less intimidating than writing long essays, making it great for building confidence.</p>
    `
  },
  {
    id: "age-appropriate-screen-time",
    title: "Age-Appropriate Screen Time Guidelines",
    excerpt: "Expert advice on balancing educational screen time with other activities for different age groups.",
    author: "Emma Williams",
    date: "January 5, 2025",
    category: "Parenting",
    content: `
      <h2>Quality Over Quantity</h2>
      <p>Not all screen time is equal. Passive watching is different from interactive educational apps.</p>
      
      <h2>Ages 2-5</h2>
      <p>Limit to 1 hour of high-quality programming. Co-viewing is recommended.</p>
      
      <h2>Ages 6+</h2>
      <p>Set consistent limits. Ensure screen time doesn't interfere with sleep or physical activity.</p>
    `
  },
  {
    id: "track-learning-progress",
    title: "How to Track Your Child's Learning Progress",
    excerpt: "Tips for parents on monitoring development and celebrating educational milestones.",
    author: "James Martinez",
    date: "December 28, 2024",
    category: "Progress Tracking",
    content: `
      <h2>Observe Play</h2>
      <p>Watch how your child solves problems during play. It reveals a lot about their cognitive growth.</p>
      
      <h2>Celebrate Small Wins</h2>
      <p>Acknowledging small milestones builds momentum and confidence.</p>
      
      <h2>Use App Analytics</h2>
      <p>Apps like Goodikids differ data-driven insights into your child's strengths and areas for improvement.</p>
    `
  },
  {
    id: "confidence-through-certificates",
    title: "Building Confidence Through Achievement Certificates",
    excerpt: "The psychology behind rewards and how certificates motivate continued learning.",
    author: "Dr. Lisa Anderson",
    date: "December 20, 2024",
    category: "Child Psychology",
    content: `
      <h2>Tangible Rewards</h2>
      <p>A physical or digital certificate gives children a sense of completion and pride.</p>
      
      <h2>Goal Setting</h2>
      <p>Working towards a certificate teaches goal-setting and perseverance.</p>
      
      <h2>Social Recognition</h2>
      <p>Sharing achievements with family boosts self-esteem and creates a positive feedback loop.</p>
    `
  },
  {
    id: "interactive-vs-traditional",
    title: "Interactive Learning vs Traditional Methods",
    excerpt: "A comparison of modern interactive approaches with traditional learning techniques.",
    author: "Robert Taylor",
    date: "December 15, 2024",
    category: "Education Research",
    content: `
      <h2>Engagement</h2>
      <p>Interactive methods keep children engaged longer than passive listening.</p>
      
      <h2>Retention</h2>
      <p>Doing and interacting leads to better memory retention than just reading or hearing.</p>
      
      <h2>Personalization</h2>
      <p>Digital tools can adapt difficulty in real-time, unlike a static textbook.</p>
    `
  }
];
